export const HOSTNAME =
  window?.location?.hostname === 'localhost'
    ? `http://${window?.location?.hostname}:${window.location.port}`
    : `https://${window?.location?.hostname}`;
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL ?? 'https://rrgjomluctgaypahcsyf.supabase.co';
export const SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ?? '';
export const SIGNED_URL_VALIDITY = 600; // seconds
export const REDEEM_CODE_VALIDITY = 30; // days
export const EXPERIENCES_STORAGE_KEY = 'experiences.v2';
export const AGAMI_GLOBAL_EXPERIENCE_ID = '679ec009-b360-40c3-bf21-ed49e4a7789c';
export const ADMIN_PANEL_AFTER = 5; // clicks
export const MANUAL_SPOT_LIBRARY_SUFFIX = '§lib_';
